<div>
  @switch (status) {
    @case ('UNKNOWN') {
      <div>
        <span
          class="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-400"
          >{{ 'qn-status-badge.unknown' | translate }}</span
        >
      </div>
    }
    @case ('NEW') {
      <div>
        <span
          class="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-purple-400 border border-purple-400"
          >{{ 'qn-status-badge.new' | translate }}</span
        >
      </div>
    }
    @case ('DRAFT') {
      <div>
        <span
          class="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-yellow-300 border border-yellow-300"
          >{{ 'qn-status-badge.draft' | translate }}</span
        >
      </div>
    }
    @case ('PENDING_PUBLISH') {
      <div>
        <span
          class="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-indigo-400 border border-indigo-400"
          >{{ 'qn-status-badge.pending-publish' | translate }}</span
        >
      </div>
    }
    @case ('PUBLISHED') {
      <div>
        <span
          class="bg-primary-100 text-primary-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-primary-400 border border-primary-400"
          >{{ 'qn-status-badge.published' | translate }}</span
        >
      </div>
    }
    @case ('FINALIZED') {
      <div>
        <span class="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-red-700 dark:text-red-400 border border-red-400">{{
          'qn-status-badge.finalized' | translate
        }}</span>
      </div>
    }
    @case ('HISTORIC') {
      <div>
        <span
          class="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded dark:bg-gray-700 dark:text-gray-400 border border-gray-500"
          >{{ 'qn-status-badge.historical' | translate }}</span
        >
      </div>
    }
  }
</div>
